<template>
  <b-modal id="memorial-preview"
           ref="memorial-preview"
           class="impressao--modal"
           :content-class="zoomClass"
           size="xl">
    <object v-if="tipo=='habilitacao' && propFilePreview != null"
            class=""
            style="height: 296mm; width: 80vh;"
            :data="`${propFilePreview }#toolbar=0&navpanes=0&scrollbar=0`"
            type="application/pdf">
      <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
    </object>
    <template v-slot:modal-footer>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            class="mr-1"
            variant="default"
            @click="$bvModal.hide('memorial-preview')">
            Voltar
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            class="ml-1"
            @click="imprimir()">
            Imprimir
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>

  export default {
    name: "ModalMemorialAditivo",
    props: {
      data: Object,
      tipo: String,
      propFilePreview: String
    },
    data () {
      return {
        impressao: {},
        zoom: 0
      }
    },
    computed: {
      zoomClass: function () {
        let className = ''

        switch (this.zoom) {
        case 2:
          className = 'modalZoom--2'
          break
        case 1:
          className = 'modalZoom--1'
          break
        case 0:
          className = ''
          break
        }

        return className
      }
    },
    watch: {
      data () {
        this.impressao = {...this.data}
      }
    },
    beforeMount () {
      this.impressao = {...this.data}
    },
    methods: {
      imprimir () {
        this.$emit('onImprimir')
      },
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../../../scss/_utilities/exports';
  @import "../../../../../../scss/_components/modals";

  .impressao{
  &--label{
     font-size: pxToRem(14);
     font-weight: 500;
   }

  &--tamanho_14{
     width: 210mm;
     min-height: 297mm;
   }

  &--modal .modal-dialog{
     max-width: 230mm;
     max-height: 297mm;
   }

  &--modal .modal-body{
     align-self: center;
     padding: 0;
   }

  }

  .font--7{
    font-size: 7pt;
  }

  .font--8{
    font-size: 8pt;
  }

  .font--10{
    font-size: 10pt;
  }

  .font--12{
    font-size: 12pt;
  }

  .font--14{
    font-size: 14pt;
  }

  .font--16{
    font-size: 16pt;
  }

  .font--18{
    font-size: 16pt;
  }

  .font-8{
    font-size: 8px;
  }

  .hr--assinatura{
    margin-top: 30px;
    margin-bottom: 0 !important;
    border-bottom: 1px solid black !important;
  }

  fieldset {
    all: initial;
    display: block !important;
    margin-inline-start: 2px !important;
    margin-inline-end: 2px !important;
    padding-block-start: 0.35em !important;
    padding-inline-start: 0.75em !important;
    padding-inline-end: 0.75em !important;
    padding-block-end: 0.625em !important;
    min-inline-size: min-content !important;
    border-width: .093699rem !important;
    border-style: groove !important;
    border-color: black !important;
    border-image: initial !important;
    font-family: Arial;
  }

  .fieldset{
    height: auto;
    padding: 2px 0 3px 0 !important;
    padding-left: 10px !important;
    margin-top: 2px;
    font-size:10px;
    text-transform: uppercase;
  }

  .fieldset-normal{
    height: auto;
    padding: 2px 0 3px 0 !important;
    padding-left: 10px !important;
    margin-top: 2px;
    font-size:10px;
  }

  legend {
    all: initial;
    display: block !important;
    padding-inline-start: 2px !important;
    padding-inline-end: 2px !important;
    border-width: initial !important;
    border-style: none !important;
    border-color: initial !important;
    border-image: initial !important;
    font-size:8px!important;
    font-family: Arial;
  }

  .fieldset--grey{
    background-color: $color-gray-light;
  }

  .bold{
    font-weight: bold;
  }

  .mlpx-5{
    margin-left: 5px !important;
  }
  .mrpx-5{
    margin-right: 5px !important;
  }

  .mlpx-10{
    margin-left: 10px !important;
  }
  .mrpx-10{
    margin-right: 10px !important;
  }

  .uppercase{
    text-transform: uppercase;
  }

  .pl-0{
    padding-left: 0 !important;
  }
</style>
